/* eslint-disable max-lines */
import { lazy } from 'react'
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import WorkIcon from '@mui/icons-material/Work'
import Groups3Icon from '@mui/icons-material/Groups3'
import {
  SummaryIcon,
  BuildingIcon2,
  PlotIconV2,
  EnergyIcon,
  SunlightIconV2,
  AmenitiesIcon,
  MarcheIcon,
  PurchaseIcon,
  RentalIcon,
} from '@popety_io/popety-io-lib'

import HistoryIcon from '@mui/icons-material/History'

const BuildingDetailsSummary = lazy(() => import('../../Summary'))
const Configuration = lazy(
  () => import('../../Configuration/ConfigurationBuilding'),
)
const BuildingEventHistory = lazy(() => import('../../BuildingEventHistory'))
const LandSummary = lazy(() => import('../../LandSummary'))
const Energy = lazy(() => import('../../Energy'))
const Livability = lazy(() => import('../../../LandDetail/Livability'))
const LandNoise = lazy(() => import('../../../LandDetail/LandNoise'))
const Sunlight = lazy(() => import('../../../LandDetail/Sunlight'))
const EstimateMarket = lazy(
  () => import('../../../Estimate/components/EstimateMarket'),
)

const EstimateCompany = lazy(() => import('../../BuildingCompany'))

const getBuildingDetailsMenuData = (
  sections: string[],
  t = (k: string) => k,
) => {
  const pages: any = [
    sections?.includes('Summary') && {
      icon: <SummaryIcon />,
      key: 'Summary',
      text: t('building.summary'),
      page: <BuildingDetailsSummary />,
      show: true,
    },
    sections?.includes('history') && {
      icon: (
        <HistoryIcon
          viewBox="2 2 20 20"
          sx={{
            width: '30px',
            height: '30px',
          }}
        />
      ),
      key: 'history',
      text: t('common.historique'),
      page: <BuildingEventHistory />,
      show: true,
    },
    sections?.includes('configuration') && {
      icon: <BuildingIcon2 />,
      key: 'configuration',
      text: t('building.configuration'),
      page: <Configuration />,
      show: true,
    },
    sections?.includes('parcelle') && {
      icon: <PlotIconV2 />,
      key: 'parcelle',
      text: t('building.info.parcelle'),
      page: <LandSummary />,
      show: true,
    },
    sections?.includes('energy') && {
      icon: <EnergyIcon />,
      key: 'energy',
      text: t('building.livability.type.energy'),
      page: <Energy />,
      show: true,
    },
    sections?.includes('company') && {
      icon: <Groups3Icon />,
      key: 'societal',
      text: t('common.societal'),
      page: <div />,
      subMenus: [
        {
          icon: <WorkIcon />,
          key: 'company',
          text: t('common.employement'),
          page: <EstimateCompany />,
          show: true,
          beta: true,
        },
      ],
      beta: true,
      show: true,
    },
    (sections?.includes('livability') ||
      sections?.includes('noise') ||
      sections?.includes('sunlight')) && {
      icon: <CrisisAlertIcon />,
      key: 'enviroment',
      text: t('building.environment'),
      page: <div />,
      subMenus: [
        sections?.includes('livability') && {
          icon: <AmenitiesIcon />,
          key: 'livability',
          text: t('common.amenities'),
          page: <Livability type="building" />,
          show: true,
        },
        sections?.includes('noise') && {
          icon: <VolumeUpIcon />,
          key: 'noise',
          text: t('common.noise'),
          page: <LandNoise type="building" />,
          show: true,
        },
        sections?.includes('sunlight') && {
          icon: <SunlightIconV2 />,
          key: 'sunlight',
          text: t('building.sunlight'),
          page: <Sunlight />,
          show: true,
        },
      ],
      show: true,
    },
    (sections?.includes('market_purchase') ||
      sections?.includes('market_rental')) && {
      icon: <MarcheIcon />,
      key: 'market',
      text: t('common.Market'),
      page: <div />,
      subMenus: [
        sections?.includes('market_purchase') && {
          icon: <PurchaseIcon />,
          key: 'purchase',
          text: t('common.Purchase'),
          page: <EstimateMarket />,
          show: true,
        },
        sections?.includes('market_rental') && {
          icon: <RentalIcon />,
          key: 'rental',
          text: t('common.Rental'),
          page: <EstimateMarket />,
          show: true,
        },
      ].filter(Boolean),
      show: true,
    },
  ].filter(Boolean)

  return pages
}

export { getBuildingDetailsMenuData }
